import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";

export default function Wallet() {

    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.personaluid;

    const [balance, setBalance] = useState(0);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) return;

        fetch(`${API_BASE}/api/get_wallet.php?user_id=${userId}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setBalance(data.balance || 0);
                    setHistory(data.history || []);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [userId]);

    return (
        <div className="container-fluid py-3" style={{ maxWidth: "1100px" }}>

            {/* ================= WALLET SUMMARY ================= */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">
                    My Wallet
                </div>

                <div className="card-body">
                    <div className="row align-items-center">

                        {/* LEFT */}
                        <div className="col-md-6">
                            <small className="text-muted">Available Balance</small>
                            <h2 className="fw-bold text-success mb-0">
                                ₹ {balance.toLocaleString()}
                            </h2>
                            <small className="text-muted">
                                Can be used for promotions & upgrades
                            </small>
                        </div>

                        {/* RIGHT */}
                        <div className="col-md-6 text-md-end mt-3 mt-md-0">
                            {balance > 0 ? (
                                <span className="badge bg-success px-3 py-2">
                                    Wallet Active
                                </span>
                            ) : (
                                <span className="badge bg-secondary px-3 py-2">
                                    No Balance
                                </span>
                            )}
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= WALLET STATUS ================= */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">
                    Wallet Status
                </div>

                <div className="card-body">
                    <table className="table table-borderless mb-0">
                        <tbody>
                            <tr>
                                <td><b>Wallet Type</b></td>
                                <td>
                                    <span className="badge bg-primary">Reward Wallet</span>
                                </td>
                            </tr>

                            <tr>
                                <td><b>Usable For</b></td>
                                <td>
                                    <span className="badge bg-success me-2">Upgrades</span>
                                    <span className="badge bg-info">Promotion</span>
                                </td>
                            </tr>



                            <tr>
                                <td><b>Status</b></td>
                                <td>
                                    {balance > 0 ? (
                                        <span className="badge bg-success">Active</span>
                                    ) : (
                                        <span className="badge bg-secondary">Inactive</span>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ================= WALLET HISTORY ================= */}
            <div className="card shadow-sm">
                <div className="card-header bg-light fw-semibold">
                    Wallet / Reward History
                </div>

                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-4 text-muted">
                            Loading wallet history...
                        </div>
                    ) : history.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            No wallet transactions found
                        </div>
                    ) : (
                        <table className="table table-hover table-sm mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th >Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {history.map((row, i) => (
                                    <tr key={i}>
                                        <td className="text-muted small">
                                            {row.date}
                                        </td>

                                        <td>
                                            <div className="fw-semibold">
                                                {row.title}
                                            </div>
                                            {row.reference && (
                                                <small className="text-muted">
                                                    Ref: {row.reference}
                                                </small>
                                            )}
                                        </td>

                                        <td className={` fw-semibold ${row.type === "credit"
                                            ? "text-success"
                                            : "text-danger"
                                            }`}>
                                            {row.type === "credit" ? "+" : "-"} ₹ {row.amount}
                                        </td>

                                        <td>
                                            <span className={`badge ${row.status === "SUCCESS"
                                                ? "bg-success"
                                                : row.status === "PENDING"
                                                    ? "bg-warning text-dark"
                                                    : "bg-danger"
                                                }`}>
                                                {row.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

        </div>
    );
}
